import React from "react";
import Routes from "./Routes";
import { LanguageProvider } from "./contexts/LanguageContext";
import SmoothScroll from "./components/SmoothScroll";

function App() {
  return (
    <LanguageProvider>
      <SmoothScroll />
      <Routes />
    </LanguageProvider>
  );
}

export default App;
